import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
// import WarningIcon from '../../../src/components/LoaderImg/Avatar.svg';

type Props = {
  close: any;
  handleSaveBtn: any;
};

const WarningIcon = () => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.5"
        width="40"
        height="40"
        rx="20"
        fill="#FEE4E2"
      />
      <path
        d="M20 14.99L27.53 28H12.47L20 14.99ZM20 11L9 30H31L20 11Z"
        fill="#F04438"
      />
      <path
        d="M21 25H19V27H21V25Z"
        fill="#F04438"
      />
      <path
        d="M21 19H19V24H21V19Z"
        fill="#F04438"
      />
    </svg>
  );
};

const PageLeaveConfirmModal = (props: Props) => {
  const { close, handleSaveBtn } = props;
  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box p={1}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  marginRight: '12px',
                }}
              >
                <WarningIcon />
              </div>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6">
                You have unsaved changes. If you leave this page before submitting, your progress
                will be lost. Are you sure you want to continue?
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            sx={{ color: '#111927' }}
            onClick={close}
          >
            Stay on Page
          </Button>
          <Button
            autoFocus
            variant="contained"
            sx={{
              background: '#F04438',
              color: '#fff',
              '&:hover': {
                background: '#F04438',
              },
            }}
            onClick={handleSaveBtn}
          >
            Leave Page & Lose Changes
          </Button>
        </DialogActions>
      </>
    </Box>
  );
};

export default PageLeaveConfirmModal;
